﻿export class ParameterGroupInfoSet {
    
    // Wind

    public static WindSpeed_kts: ParameterGroupInfo = {
        Id: 'WindSpeed_kts',
        ShortName: 'Wind Spd',
        Units: 'kts',
        Description: 'Scalar mean speed of wind velocity',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static GustSpeed_kts: ParameterGroupInfo = {
        Id: 'GustSpeed_kts',
        ShortName: 'Gust Spd',
        Units: 'kts',
        Description: 'Maximum gust speed in recording interval',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static WindDirection_deg: ParameterGroupInfo = {
        Id: 'WindDirection_deg',
        ShortName: 'Wind Dir.',
        Units: '°T FROM',
        Description: 'Vector mean direction of wind velocity',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static WindDirection_Backed_deg: ParameterGroupInfo = {
        Id: 'WindDirection_Backed_deg',
        ShortName: 'Wind Backed',
        Units: '°T FROM',
        Description: 'Maximum counter-clockwise extent of wind variation',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static WindDirection_Veered_deg: ParameterGroupInfo = {
        Id: 'WindDirection_Veered_deg',
        ShortName: 'Wind Veered',
        Units: '°T FROM',
        Description: 'Maximum clockwise extent of wind variation',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static WindSelectedSensorId: ParameterGroupInfo = {
        Id: 'WindSelectedSensorId',
        ShortName: 'Wind Selected Sensor',
        Units: null,
        Description: 'The selected wind sensor',
        Format: null,
        Plottable: false
    };

    // Wind Fixed Interval

    public static WindSpeed_kts_10min: ParameterGroupInfo = {
        Id: 'WindSpeed_kts_10min', 
        ShortName: 'Wind Spd (10 min)',
        Units: 'kts',
        Description: 'Vector mean speed of wind velocity',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static GustSpeed_kts_10min: ParameterGroupInfo = {
        Id: 'GustSpeed_kts_10min',
        ShortName: 'Gust Spd (10 min)',
        Units: 'kts',
        Description: 'Maximum gust speed in recording interval',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static WindDirection_deg_10min: ParameterGroupInfo = {
        Id: 'WindDirection_deg_10min',
        ShortName: 'Wind Dir. (10 min)',
        Units: '°T FROM',
        Description: 'Vector mean direction of wind velocity',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static WindSpeed_kts_1min: ParameterGroupInfo = {
        Id: 'WindSpeed_kts_1min',
        ShortName: 'Wind Spd (1 min)',
        Units: 'kts',
        Description: 'Vector mean speed of wind velocity',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static GustSpeed_kts_1min: ParameterGroupInfo = {
        Id: 'GustSpeed_kts_1min',
        ShortName: 'Gust Spd (1 min)',
        Units: 'kts',
        Description: 'Maximum gust speed in recording interval',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static WindDirection_deg_1min: ParameterGroupInfo = {
        Id: 'WindDirection_deg_1min',
        ShortName: 'Wind Dir. (1 min)',
        Units: '°T FROM',
        Description: 'Vector mean direction of wind velocity',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static WindSpeed_kts_10m: ParameterGroupInfo = {
        Id: 'WindSpeed_kts_10m',
        ShortName: 'Wind Spd 10m',
        Units: 'kts',
        Description: 'Scalar mean speed of wind velocity at 10m',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static GustSpeed_kts_10m: ParameterGroupInfo = {
        Id: 'GustSpeed_kts_10m',
        ShortName: 'Gust Spd 10m',
        Units: 'kts',
        Description: 'Maximum gust speed at 10m in recording interval',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static WindSpeed_kts_10m_1min: ParameterGroupInfo = {
        Id: 'WindSpeed_kts_10m_1min',
        ShortName: 'Wind Spd 10m (1 min)',
        Units: 'kts',
        Description: 'Vector mean speed of wind velocity at 10m',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static GustSpeed_kts_10m_1min: ParameterGroupInfo = {
        Id: 'GustSpeed_kts_10m_1min',
        ShortName: 'Gust Spd 10m (1 min)',
        Units: 'kts',
        Description: 'Maximum gust speed at 10m in recording interval',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static WindSpeed_kts_10m_10min: ParameterGroupInfo = {
        Id: 'WindSpeed_kts_10m_10min',
        ShortName: 'Wind Spd 10m (10 min)',
        Units: 'kts',
        Description: 'Vector mean speed of wind velocity at 10m',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };

    public static GustSpeed_kts_10m_10min: ParameterGroupInfo = {
        Id: 'GustSpeed_kts_10m_10min',
        ShortName: 'Gust Spd 10m (10 min)',
        Units: 'kts',
        Description: 'Maximum gust speed at 10m in recording interval',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0
    };


    // Meteorological

    public static AirTemperature_degC: ParameterGroupInfo = {
        Id: 'AirTemperature_degC',
        ShortName: 'Air Temp',
        Units: '°C',
        Description: 'Dry bulb air temperature',
        Format: '%.1f',
        Plottable: true
    };

    public static WaterTemp_degC: ParameterGroupInfo = {
        Id: 'WaterTemp_degC',
        ShortName: 'Water Temp',
        Units: '°C',
        Description: 'Water temperature',
        Format: '%.1f',
        Plottable: true
    };

    public static QFE_mbar: ParameterGroupInfo = {
        Id: 'QFE_mbar',
        ShortName: 'QFE',
        Units: 'hPa',
        Description: 'Barometric pressure adjusted to field elevation',
        Format: '%.1f',
        Plottable: true
    };

    public static QFE_mbar_HelideckC: ParameterGroupInfo = {
        Id: 'QFE_mbar',
        ShortName: 'QFE C',
        Units: 'hPa',
        Description: 'Barometric pressure adjusted to field elevation',
        Format: '%.1f',
        Plottable: true
    };

    public static QFE_mbar_HelideckP: ParameterGroupInfo = {
        Id: 'QFE_mbar',
        ShortName: 'QFE P',
        Units: 'hPa',
        Description: 'Barometric pressure adjusted to field elevation',
        Format: '%.1f',
        Plottable: true
    };

    public static QNH_mbar: ParameterGroupInfo = {
        Id: 'QNH_mbar',
        ShortName: 'QNH',
        Units: 'hPa',
        Description: 'Barometric pressure adjusted to sea level',
        Format: '%.1f',
        Plottable: true
    };

    public static DewPoint_degC: ParameterGroupInfo = {
        Id: 'DewPoint_degC',
        ShortName: 'Dew Point',
        Units: '°C',
        Description: 'The temperature at which condensation occurs',
        Format: '%.1f',
        Plottable: true
    };

    public static RelativeHumidity_pc: ParameterGroupInfo = {
        Id: 'RelativeHumidity_pc',
        ShortName: 'Humidity',
        Units: '%',
        Description: 'Percentage of the maximum possible amount of water contained in the air',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 100
    };

    public static WindChill_degC: ParameterGroupInfo = {
        Id: 'WindChill_degC',
        ShortName: 'Wind Chill',
        Units: '°C',
        Description: 'The apparent temperature felt on exposed skin due to wind',
        Format: '%.1f',
        Plottable: true
    };

    public static SolarRadiation_mWpcm2: ParameterGroupInfo = {
        Id: 'SolarRadiation_mWpcm2',
        ShortName: 'Solar Rad.',
        Units: 'mW/cm^2',
        Description: 'Solar radiation flux density',
        Format: '%.1f',
        Plottable: true
    };

    public static METAR: ParameterGroupInfo = {
        Id: 'METAR',
        ShortName: 'METAR',
        Units: null,
        Description: 'METAR',
        Format: null,
        Plottable: false
    };

    // Cloud, Vis, Weather

    public static Visibility_m: ParameterGroupInfo = {
        Id: 'Visibility_m',
        ShortName: 'Visibility',
        Units: 'm',
        Description: 'Distance that can be seen clearly',
        Format: '%.0f',
        Plottable: true
    };

    public static PresentWeather: ParameterGroupInfo = {
        Id: 'PresentWeather',
        ShortName: 'Present Weather',
        Units: null,
        Description: 'Present Weather in METAR coding format',
        Format: null,
        Plottable: false
    };

    public static RainfallIntensity_mmphour: ParameterGroupInfo = {
        Id: 'RainfallIntensity_mmphour',
        ShortName: 'Rainfall',
        Units: 'mm / hour',
        Description: 'Total rainfall in 1 hour',
        Format: '%.1f',
        Plottable: true
    };

    public static First_CloudBaseHeight_ft: ParameterGroupInfo = {
        Id: 'First_CloudBaseHeight_ft',
        ShortName: 'Cloud Ht 1',
        Units: 'ft',
        Description: 'Height of lowest cloud base',
        Format: '%.0f',
        Plottable: true,
        PlotLine: false,
        AxisMin: 0
    };

    public static Second_CloudBaseHeight_ft: ParameterGroupInfo = {
        Id: 'Second_CloudBaseHeight_ft',
        ShortName: 'Cloud Ht 2',
        Units: 'ft',
        Description: 'Height of second lowest cloud base',
        Format: '%.0f',
        Plottable: true,
        PlotLine: false,
        AxisMin: 0
    };

    public static Third_CloudBaseHeight_ft: ParameterGroupInfo = {
        Id: 'Third_CloudBaseHeight_ft',
        ShortName: 'Cloud Ht 3',
        Units: 'ft',
        Description: 'Height of third lowest cloud base',
        Format: '%.0f',
        Plottable: true,
        PlotLine: false,
        AxisMin: 0
    };

    public static First_CloudCover: ParameterGroupInfo = {
        Id: 'First_CloudCover',
        ShortName: 'Cloud Amt 1',
        Units: null,
        Description: 'The amount of sky obscured by clouds in the lowest cloud base',
        Format: null,
        Plottable: false
    };

    public static Second_CloudCover: ParameterGroupInfo = {
        Id: 'Second_CloudCover',
        ShortName: 'Cloud Amt 2',
        Units: null,
        Description: 'The amount of sky obscured by clouds in the second lowest cloud base',
        Format: null,
        Plottable: false
    };

    public static Third_CloudCover: ParameterGroupInfo = {
        Id: 'Third_CloudCover',
        ShortName: 'Cloud Amt 3',
        Units: null,
        Description: 'The amount of sky obscured by clouds in the third lowest cloud base',
        Format: null,
        Plottable: false
    };

    public static First_CloudBaseHeight_ft_Inst: ParameterGroupInfo = {
        Id: 'First_CloudBaseHeight_ft_Inst',
        ShortName: 'Cloud Ht 1 Inst',
        Units: 'ft',
        Description: 'Instantaneous height of lowest cloud base',
        Format: '%.0f',
        Plottable: true,
        PlotLine: false,
        AxisMin: 0
    };

    public static Second_CloudBaseHeight_ft_Inst: ParameterGroupInfo = {
        Id: 'Second_CloudBaseHeight_ft_Inst',
        ShortName: 'Cloud Ht 2 Inst',
        Units: 'ft',
        Description: 'Instantaneous height of second lowest cloud base',
        Format: '%.0f',
        Plottable: true,
        PlotLine: false,
        AxisMin: 0
    };

    public static Third_CloudBaseHeight_ft_Inst: ParameterGroupInfo = {
        Id: 'Third_CloudBaseHeight_ft_Inst',
        ShortName: 'Cloud Ht 3 Inst',
        Units: 'ft',
        Description: 'Instantaneous height of third lowest cloud base',
        Format: '%.0f',
        Plottable: true,
        PlotLine: false,
        AxisMin: 0
    };

    // Vessel

    public static Heading_deg: ParameterGroupInfo = {
        Id: 'Heading_deg',
        ShortName: 'Heading',
        Units: '°',
        Description: 'Heading towards which bow of vessel is pointing',
        Format: '%.0f',
        Plottable: true
    };

    public static Vessel_Latitude_deg: ParameterGroupInfo = {
        Id: 'Vessel_Latitude_deg',
        ShortName: 'Latitude',
        Units: '°',
        Description: 'Vessel Latitude',
        Format: '%.3f',
        Plottable: true
    };

    public static Vessel_Longitude_deg: ParameterGroupInfo = {
        Id: 'Vessel_Longitude_deg',
        ShortName: 'Longitude',
        Units: '°',
        Description: 'Vessel Longitude',
        Format: '%.3f',
        Plottable: true
    };

    public static PitchBowUp_deg_Max: ParameterGroupInfo = {
        Id: 'PitchBowUp_deg_Max',
        ShortName: 'Max Pitch Bow Up',
        Units: '°',
        Description: 'Maximum angle of rotation from vertical, positive bow up',
        Format: '%.1f',
        Plottable: true
    };

    public static PitchBowDown_deg_Max: ParameterGroupInfo = {
        Id: 'PitchBowDown_deg_Max',
        ShortName: 'Max Pitch Bow Down',
        Units: '°',
        Description: 'Maximum angle of rotation from vertical, positive bow down',
        Format: '%.1f',
        Plottable: true
    };

    public static Roll_Left_deg_Max: ParameterGroupInfo = {
        Id: 'Roll_Left_deg_Max',
        ShortName: 'Max Roll Left',
        Units: '°',
        Description: 'Maximum angle of rotation from vertical, positive portside down',
        Format: '%.1f',
        Plottable: true
    };

    public static Roll_Right_deg_Max: ParameterGroupInfo = {
        Id: 'Roll_Right_deg_Max',
        ShortName: 'Max Roll Right',
        Units: '°',
        Description: 'Maximum angle of rotation from vertical, positive portside up',
        Format: '%.1f',
        Plottable: true
    };

    public static Inclination_deg_Max: ParameterGroupInfo = {
        Id: 'Inclination_deg_Max',
        ShortName: 'Max Inclination',
        Units: '°',
        Description: 'Maximum angle of deck from normal',
        Format: '%.1f',
        Plottable: true
    };

    public static Heave_Rate_mps_Max: ParameterGroupInfo = {
        Id: 'Heave_Rate_mps_Max',
        ShortName: 'Max Heave Rate',
        Units: 'm/s',
        Description: 'Maximum rate of vertical displacement',
        Format: '%.1f',
        Plottable: true
    };

    public static Heave_Period_s_Mean: ParameterGroupInfo = {
        Id: 'Heave_Period_s_Mean',
        ShortName: 'Mean Heave Period',
        Units: 's',
        Description: 'Mean period of vertical displacement motion',
        Format: '%.1f',
        Plottable: true
    };

    public static Heave_m_Max: ParameterGroupInfo = {
        Id: 'Heave_m_Max',
        ShortName: 'Max Heave',
        Units: 'm',
        Description: 'Maximum magnitude of vertical displacement',
        Format: '%.1f',
        Plottable: true
    };

    public static MMS: ParameterGroupInfo = {
        Id: 'MMS',
        ShortName: 'MMS',
        Units: null,
        Description: 'Measure of motion severity',
        Format: '%.1f',
        Plottable: true
    };

    public static MSI: ParameterGroupInfo = {
        Id: 'MSI',
        ShortName: 'MSI',
        Units: null,
        Description: 'Motion severity index',
        Format: '%.1f',
        Plottable: true
    };

    public static Excursion_Distance_m_Max: ParameterGroupInfo = {
        Id: 'Excursion_Distance_m_Max',
        ShortName: 'Max Excursion',
        Units: 'm',
        Description: 'Maximum Excursion Distance',
        Format: '%.1f',
        Plottable: true
    };

    public static Excursion_Bearing_deg: ParameterGroupInfo = {
        Id: 'Excursion_Bearing_deg',
        ShortName: 'Excursion Bearing',
        Units: '°T FROM',
        Description: 'Bearing of Maximum Excursion',
        Format: '%03.0f',
        Plottable: true
    };

    // Wave

    public static Hs_m: ParameterGroupInfo = {
        Id: 'Hs_m',
        ShortName: 'Hs',
        Units: 'm',
        Description: 'Significant wave height',
        Format: '%.1f',
        Plottable: true,
        AxisMin: 0
    };

    public static Hmax_m: ParameterGroupInfo = {
        Id: 'Hmax_m',
        ShortName: 'Hmax',
        Units: 'm',
        Description: 'Maximum upcrossing individual wave height from time domain',
        Format: '%.1f',
        Plottable: true,
        AxisMin: 0
    };

    public static Cmax_m: ParameterGroupInfo = {
        Id: 'Cmax_m',
        ShortName: 'Cmax',
        Units: 'm',
        Description: 'Maximum crest height',
        Format: '%.1f',
        Plottable: true,
        AxisMin: 0
    };

    public static Cass_m: ParameterGroupInfo = {
        Id: 'Cass_m',
        ShortName: 'Cass',
        Units: 'm',
        Description: 'Crest associated with the maximum wave height',
        Format: '%.1f',
        Plottable: false,
        AxisMin: 0
    };

    public static Tp_s: ParameterGroupInfo = {
        Id: 'Tp_s',
        ShortName: 'Tp',
        Units: 's',
        Description: 'Spectral peak period of the full spectrum',
        Format: '%.1f',
        Plottable: true,
        AxisMin: 0,
        PlotLine: false,
    };

    public static Tz_s: ParameterGroupInfo = {
        Id: 'Tz_s',
        ShortName: 'Tz',
        Units: 's',
        Description: 'Mean zero-upcrossing wave period from time domain',
        Format: '%.1f',
        Plottable: true,
        AxisMin: 0
    };

    public static T2_s: ParameterGroupInfo = {
        Id: 'T2_s',
        ShortName: 'T2',
        Units: 's',
        Description: 'Average wave period defined by SQRT(M0/M2) from frequency domain',
        Format: '%.1f',
        Plottable: true,
        AxisMin: 0
    };


    public static MeanWaveDirection_deg: ParameterGroupInfo = {
        Id: 'MeanWaveDirection_deg',
        ShortName: 'Mean Dir.',
        Units: '°T FROM',
        Description: 'Average wave direction of the full spectrum',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static PeakWaveDirection_deg: ParameterGroupInfo = {
        Id: 'PeakWaveDirection_deg',
        ShortName: 'Peak Dir.',
        Units: '°T FROM',
        Description: 'Peak wave direction of the full spectrum',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static PeakSpreading_deg: ParameterGroupInfo = {
        Id: 'PeakSpreading_deg',
        ShortName: 'Peak Spread',
        Units: '°',
        Description: 'Directional spreading of peak frequency',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static MeanSpreading_deg: ParameterGroupInfo = {
        Id: 'MeanSpreading_deg',
        ShortName: 'Mean Spread',
        Units: '°',
        Description: 'Average directional spreading of the full spectrum',
        Format: '%.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static WaveSpectrum: ParameterGroupInfo = {
        Id: 'WaveSpectrum',
        ShortName: 'Spectrum',
        Units: null,
        Description: 'Wave spectrum',
        Format: null,
        Plottable: false
    };

    // Current

    public static Total_CurrentSpeed_Peak_mps_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentSpeed_Peak_mps_Mean',
        ShortName: 'Peak Current Spd',
        Units: 'mps',
        Description: 'Peak current speed',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_CurrentDirection_Peak_deg_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentDirection_Peak_deg_Mean',
        ShortName: 'Peak Current Dir.',
        Units: '°T TO',
        Description: 'Peak current direction',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };

    public static MeasurementDepth_Total_Current_Peak_deg_Mean: ParameterGroupInfo = {
        Id: 'MeasurementDepth_Total_Current_Peak_deg_Mean',
        ShortName: 'Peak Current Depth',
        Units: 'm',
        Description: 'Peak current depth',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_CurrentSpeed_Surface_mps_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentSpeed_Surface_mps_Mean',
        ShortName: 'Near Sfc. Current Spd',
        Units: 'mps',
        Description: 'Near surface current speed',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_CurrentDirection_Surface_deg_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentDirection_Surface_deg_Mean',
        ShortName: 'Near Sfc. Current Dir.',
        Units: '°T TO',
        Description: 'Near surface current direction',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };
    public static Total_CurrentSpeed_Middle_mps_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentSpeed_Middle_mps_Mean',
        ShortName: 'Mid. Current Spd',
        Units: 'mps',
        Description: 'Middle current speed',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_CurrentDirection_Middle_deg_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentDirection_Middle_deg_Mean',
        ShortName: 'Mid. Current Dir.',
        Units: '°T TO',
        Description: 'Middle current direction',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };
    public static Total_CurrentSpeed_Bottom_mps_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentSpeed_Bottom_mps_Mean',
        ShortName: 'Bottom Current Spd',
        Units: 'mps',
        Description: 'Btm. current speed',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_CurrentDirection_Bottom_deg_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentDirection_Bottom_deg_Mean',
        ShortName: 'Btm. Current Dir.',
        Units: '°T TO',
        Description: 'Bottom current direction',
        Format: '%03.0f',
        Plottable: true,
        AxisMin: 0,
        AxisMax: 360,
        PlotLine: false
    };


    public static Total_CurrentSpeed_Peak_kts_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentSpeed_Peak_kts_Mean',
        ShortName: 'Peak Current Spd',
        Units: 'kts',
        Description: 'Peak current speed',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_CurrentSpeed_Surface_kts_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentSpeed_Surface_kts_Mean',
        ShortName: 'Sfc. Current Spd',
        Units: 'kts',
        Description: 'Surface current speed',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_CurrentSpeed_Middle_kts_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentSpeed_Middle_kts_Mean',
        ShortName: 'Mid. Current Spd',
        Units: 'kts',
        Description: 'Middle current speed',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_CurrentSpeed_Bottom_kts_Mean: ParameterGroupInfo = {
        Id: 'Total_CurrentSpeed_Bottom_kts_Mean',
        ShortName: 'Bottom Current Spd',
        Units: 'kts',
        Description: 'Btm. current speed',
        Format: '%.1f',
        Plottable: true
    };

    public static CurrentProfile: ParameterGroupInfo = {
        Id: 'CurrentProfile',
        ShortName: 'Current Profile',
        Units: 'm',
        Description: 'Current Profile',
        Format: '%.1f',
        Plottable: true
    };

    // Water Level

    public static Total_SeaElevation_m_Mean: ParameterGroupInfo = {
        Id: 'Total_SeaElevation_m_Mean',
        ShortName: 'Mean WL',
        Units: 'm',
        Description: 'Total water level (Mean)',
        Format: '%.1f',
        Plottable: true
    };

    public static Total_SeaElevation_m_Max: ParameterGroupInfo = {
        Id: 'Total_SeaElevation_m_Max',
        ShortName: 'Max TWL',
        Units: 'm',
        Description: 'Total water level (Max)',
        Format: '%.1f',
        Plottable: true
    };

    public static AirGap_m: ParameterGroupInfo = {
        Id: 'AirGap_m',
        ShortName: 'Air Gap',
        Units: 'm',
        Description: 'Radar air gap (Mean)',
        Format: '%.1f',
        Plottable: true
    };

    // Wave Buoy

    public static Buoy_Latitude_deg: ParameterGroupInfo = {
        Id: 'Buoy_Latitude_deg',
        ShortName: 'Latitude',
        Units: '°',
        Description: 'Buoy Latitude',
        Format: '%.5f',
        Plottable: true
    };

    public static Buoy_Longitude_deg: ParameterGroupInfo = {
        Id: 'Buoy_Longitude_deg',
        ShortName: 'Longitude',
        Units: '°',
        Description: 'Buoy Longitude',
        Format: '%.5f',
        Plottable: true
    };

    public static Buoy_Excursion_m: ParameterGroupInfo = {
        Id: 'Buoy_Excursion_m',
        ShortName: 'Excursion',
        Units: 'm',
        Description: 'Buoy excursion from target location',
        Format: '%.0f',
        Plottable: true
    };

    // Helideck Status
    public static Helideck_Status: ParameterGroupInfo = {
        Id: 'Helideck_Status',
        ShortName: 'Helideck Status',
        Units: 'm',
        Description: 'Helideck status based on station-specific wind speed and direction rules',
        Format: '1d',
        Plottable: true
    };

    //Riser tension (implemented initially for Malikai)

    public static RiserTension_kN: ParameterGroupInfo = {
        Id: 'RiserTension_kN',
        ShortName: 'Riser Tension',
        Units: 'kN',
        Description: 'Riser tension',
        Format: '%.1f',
        Plottable: false
    };

    public static RiserTensionerPressure1_psi: ParameterGroupInfo = {
        Id: 'RiserTensionerPressure1_psi',
        ShortName: 'Tensioner Pressure (PT1)',
        Units: 'psi',
        Description: 'Tensioner pressure (PT1)',
        Format: '%.1f',
        Plottable: false
    };

    public static RiserTensionerPressure2_psi: ParameterGroupInfo = {
        Id: 'RiserTensionerPressure2_psi',
        ShortName: 'Tensioner Pressure (PT2)',
        Units: 'psi',
        Description: 'Tensioner pressure (PT2)',
        Format: '%.1f',
        Plottable: false
    };

    public static RiserTensionerPressure3_psi: ParameterGroupInfo = {
        Id: 'RiserTensionerPressure3_psi',
        ShortName: 'Tensioner Pressure (PT3)',
        Units: 'psi',
        Description: 'Tensioner pressure (PT3)',
        Format: '%.1f',
        Plottable: false
    };

    public static RiserTensionerPressure4_psi: ParameterGroupInfo = {
        Id: 'RiserTensionerPressure4_psi',
        ShortName: 'Tensioner Pressure (PT4)',
        Units: 'psi',
        Description: 'Tensioner pressure (PT4)',
        Format: '%.1f',
        Plottable: false
    };

    public static Pitch_deg: ParameterGroupInfo = {
        Id: 'Pitch_deg',
        ShortName: 'Pitch',
        Units: '°',
        Description: 'Pitch',
        Format: '%.1f',
        Plottable: false
    };

    public static Roll_deg: ParameterGroupInfo = {
        Id: 'Roll_deg',
        ShortName: 'Roll',
        Units: '°',
        Description: 'Roll',
        Format: '%.1f',
        Plottable: false
    };

    public static SurgeAcceleration_mps2: ParameterGroupInfo = {
        Id: 'SurgeAcceleration_mps2',
        ShortName: 'Surge Acceleration',
        Units: 'm/s²',
        Description: 'Surge Acceleration',
        Format: '%.1f',
        Plottable: false
    };

    public static SwayAcceleration_mps2: ParameterGroupInfo = {
        Id: 'SwayAcceleration_mps2',
        ShortName: 'Sway Acceleration',
        Units: 'm/s²',
        Description: 'Sway Acceleration',
        Format: '%.1f',
        Plottable: false
    };

    public static Heave_m: ParameterGroupInfo = {
        Id: 'Heave_m',
        ShortName: 'Heave',
        Units: 'm',
        Description: 'Heave',
        Format: '%.1f',
        Plottable: false
    };

    public static Draft_m: ParameterGroupInfo = {
        Id: 'Draft_m',
        ShortName: 'Draft',
        Units: 'm',
        Description: 'Draft',
        Format: '%.1f',
        Plottable: false
    };

    public static InclinationNS_deg: ParameterGroupInfo = {
        Id: 'InclinationNS_deg',
        ShortName: 'Inclination NS',
        Units: '°',
        Description: 'Inclination NS',
        Format: '%.1f',
        Plottable: false
    };

    public static InclinationEW_deg: ParameterGroupInfo = {
        Id: 'InclinationEW_deg',
        ShortName: 'Inclination EW',
        Units: '°',
        Description: 'Inclination EW',
        Format: '%.1f',
        Plottable: false
    };

    public static TEMPSC_Status: ParameterGroupInfo = {
        Id: 'TEMPSC_Status',
        ShortName: 'TEMPSC Status',
        Units: null,
        Description: 'TEMPSC Status',
        Format: null,
        Plottable: false
    };
}


export interface ParameterGroupInfo {
    Id: string;
    ShortName: string;
    Units: string;
    Description: string;
    Format: string;
    Plottable: boolean;
    PlotLine?: boolean;
    AxisMin?: number;
    AxisMax?: number;
}